module.exports = __webpack_public_path__ + "static/img/lotte-tms-thumb.4154e82.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/lotte-tms-thumb.jpg
// module id = Vv6P
// module chunks = 0